import React from "react";
import PropTypes from "kf-proptypes/widgets";

import styles from "./overlay.css";

export function Overlay(props) {
  const { className, isGlobal, onClick } = props;
  return (
    <div
      className={`${styles.overlay} ${
        isGlobal ? styles.global : ""
      } ${className}`}
      onClick={onClick}
      data-component="overlay"
    />
  );
}

Overlay.propTypes = {
  /**
   * To overcome defualt styles of component
   */
  className: PropTypes.string,
  /**
   * overlay applied full viewport if isGlobal is true
   */
  isGlobal: PropTypes.bool,
  /**
   * Trigger when user click the overlay
   */
  onClick: PropTypes.func
};
